import { useState } from 'react'

import { kmhToMs, ru } from '../../lib/physics'
import { Predict, Slider, useFrames } from './common'

/**
 * Метры в секунду и километры в час (урок 8): одна и та же скорость в двух единицах.
 * Машина едет, рядом два счётчика: метры за прошедшие секунды и километры за часы.
 * 1 м/с = 3,6 км/ч: в часе 3600 секунд, а в километре всего 1000 метров.
 */

const PX_PER_M = 4
const ДОРОГА = 320

export default function SpeedLab() {
  const [kmh, setKmh] = useState(18)
  const [t, setT] = useState(0) // с
  const [идёт, setИдёт] = useState(false)

  const v = kmhToMs(kmh)
  const путь = v * t
  useFrames((dt) => {
    if (!идёт) return
    setT((x) => {
      const n = x + dt
      if (v * n * PX_PER_M > ДОРОГА) {
        setИдёт(false)
        return ДОРОГА / PX_PER_M / v
      }
      return n
    })
  })
  const x = 20 + путь * PX_PER_M

  return (
    <div className="card">
      <svg className="lab-svg" viewBox="0 0 360 90" role="img" aria-label="Машина на дороге">
        <line x1={10} y1={62} x2={350} y2={62} className="ink-muted" strokeWidth={2} />
        {Array.from({ length: 9 }, (_, i) => (
          <g key={i}>
            <line x1={20 + i * 40} y1={62} x2={20 + i * 40} y2={70} className="ink-muted" />
            <text x={20 + i * 40} y={82} textAnchor="middle" className="lab-tick">{i * 10} м</text>
          </g>
        ))}
        <rect x={x - 30} y={38} width={30} height={16} rx={4} className="fill-heavy" />
        <circle cx={x - 23} cy={57} r={5} className="fill-muted" />
        <circle cx={x - 7} cy={57} r={5} className="fill-muted" />
      </svg>

      <div className="lab-readout">
        <span>прошло {ru(t, 1)} с</span>
        <span className="heavy">проехала {ru(путь, 1)} м</span>
        <span className="el">скорость {ru(v, 2)} м/с = {ru(kmh, 0)} км/ч</span>
      </div>
      <div className="lab-caption">
        {ru(kmh, 0)} км/ч = {ru(kmh, 0)} · 1000 м : 3600 с = {ru(kmh, 0)} : 3,6 = {ru(v, 2)} м/с
      </div>

      <Slider label="Скорость" value={kmh} min={3.6} max={72} step={3.6} unit="км/ч" shown={ru(kmh, 1)} onChange={(x2) => { setKmh(x2); setT(0); setИдёт(false) }} />
      <div className="row-wrap" style={{ marginTop: 12 }}>
        <button className="btn btn-primary" onClick={() => { setT(0); setИдёт(true) }}>▶️ Поехали</button>
      </div>

      <Predict
        question="Машина едет со скоростью 18 км/ч. Сколько метров она проезжает за секунду?"
        options={['18 м', '5 м', '1,8 м']}
        right={1}
        revealed={!идёт && t > 0 && Math.abs(kmh - 18) < 1e-9}
        explain="18 км/ч = 18 000 м за 3600 с = 5 м/с. Короче: км/ч делим на 3,6 — получаем м/с; м/с умножаем на 3,6 — км/ч."
      />
    </div>
  )
}
